import React from 'react';
import { FadeIn, SectionTitle, Card } from '../components/UI';

export default function AboutPage({ content = {} }) {
  return (
    <div style={{ paddingTop: 100, background: 'var(--dark)' }}>
      <section style={{ padding: '60px 40px 100px', maxWidth: 1100, margin: '0 auto' }}>
        <FadeIn>
          <SectionTitle subtitle={content.subtitle || 'About Us'} title={content.title || 'The people behind the technology'} />
        </FadeIn>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 48, alignItems: 'start',
        }}>
          <FadeIn delay={0.1}>
            <div>
              {[
                content.intro || <span key="a">
                  <strong style={{ color: 'var(--text-primary)' }}>
                    KNOW<span style={{ color: 'var(--cyan)' }}>IT</span> SOLUTIONS
                  </strong>{' '}
                  was founded with a simple belief: technology should empower businesses,
                  not complicate them. With over 15 years of experience across cloud,
                  infrastructure, web development and IT strategy, we bring enterprise-level
                  expertise to organisations of every size.
                </span>,
                'Based in the UK, we specialise in Microsoft technologies — Azure, .NET, and the wider Microsoft ecosystem — delivering solutions that are robust, scalable and secure.',
                "We're not just a vendor — we're a partner. We take the time to understand your business, your challenges, and your goals before recommending a single line of code or cloud resource.",
              ].map((text, i) => (
                <p key={i} style={{
                  fontFamily: 'var(--font-body)', fontSize: '1.05rem',
                  fontWeight: 300, color: 'var(--text-secondary)',
                  lineHeight: 1.8, marginBottom: 18,
                }}>{text}</p>
              ))}
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              {[
                { title: 'Our Mission', text: 'To deliver IT solutions that genuinely make a difference — removing complexity, improving efficiency, and enabling growth.' },
                { title: 'Our Approach', text: 'Consultative-first. We listen, we plan, we execute — with transparency and accountability at every stage.' },
                { title: 'Our Stack', text: 'Microsoft Azure, .NET / C#, React, SQL Server, DevOps, Terraform, and more. We choose the right tools for the job.' },
              ].map((item, i) => (
                <Card key={i}>
                  <h4 style={{
                    fontFamily: 'var(--font-body)', fontWeight: 600,
                    color: 'var(--cyan)', fontSize: '0.95rem', marginBottom: 6,
                  }}>{item.title}</h4>
                  <p style={{
                    fontFamily: 'var(--font-body)', fontSize: '0.88rem',
                    fontWeight: 300, color: 'var(--text-secondary)', lineHeight: 1.6,
                  }}>{item.text}</p>
                </Card>
              ))}
            </div>
          </FadeIn>
        </div>

        {/* Values */}
        <FadeIn delay={0.1} style={{ marginTop: 72 }}>
          <h3 style={{
            fontFamily: 'var(--font-body)', fontWeight: 700,
            fontSize: '1.4rem', color: 'var(--text-primary)', marginBottom: 28,
          }}>Our Values</h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 18,
          }}>
            {[
              { icon: '🎯', title: 'Precision', desc: 'Every solution is engineered with care and attention to detail.' },
              { icon: '💡', title: 'Innovation', desc: "We stay at the cutting edge so our clients don't have to." },
              { icon: '🤝', title: 'Partnership', desc: "Your success is our success. We're in it together." },
              { icon: '🔐', title: 'Trust', desc: 'Transparent communication, honest advice, no hidden agendas.' },
            ].map((v, i) => (
              <Card key={i}>
                <div style={{ fontSize: '1.6rem', marginBottom: 10 }}>{v.icon}</div>
                <h4 style={{
                  fontFamily: 'var(--font-body)', fontWeight: 600,
                  color: 'var(--text-primary)', marginBottom: 5, fontSize: '0.95rem',
                }}>{v.title}</h4>
                <p style={{
                  fontFamily: 'var(--font-body)', fontSize: '0.83rem',
                  fontWeight: 300, color: 'var(--text-secondary)', lineHeight: 1.6,
                }}>{v.desc}</p>
              </Card>
            ))}
          </div>
        </FadeIn>
      </section>
    </div>
  );
}
